// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import merge from 'lodash.merge';
import { useContext, useMemo } from 'react';
import { DesignsContext } from '../contexts/designs';
function composeDesign(designSet, getDesign) {
    if ((designSet === null || designSet === void 0 ? void 0 : designSet._extends) && Array.isArray(designSet._extends)) {
        return designSet._extends.reduce(function (acc, _extends) {
            acc = merge({}, acc, composeDesign({ _extends: _extends }, getDesign));
            return acc;
        }, designSet);
    }
    var designExtension = getDesign(designSet === null || designSet === void 0 ? void 0 : designSet._extends);
    if (designExtension === null || designExtension === void 0 ? void 0 : designExtension._extends) {
        designExtension = composeDesign(designExtension, getDesign);
    }
    return {
        components: merge({}, designExtension === null || designExtension === void 0 ? void 0 : designExtension.components, designSet.components),
        config: merge({}, designExtension === null || designExtension === void 0 ? void 0 : designExtension.config, designSet.config),
        schema: merge({}, designExtension === null || designExtension === void 0 ? void 0 : designExtension.schema, designSet.schema),
    };
}
var useDesign = function (design) {
    var getDesign = useContext(DesignsContext).getDesign;
    var designSet = getDesign(design);
    var composition = useMemo(function () { return composeDesign(designSet, getDesign); }, [design]);
    return composition;
};
export default useDesign;
